(function() {
  function initSection(section) {
    var tabs = section.querySelectorAll('.advanced-tabbed-section__tab');
    var contents = section.querySelectorAll('.advanced-tabbed-section__content');
    function deactivate() {
      tabs.forEach(function(tab) { tab.classList.remove('active'); });
      contents.forEach(function(content) { content.style.display = 'none'; });
    }
    deactivate();
    if (tabs.length > 0) {
      tabs[0].classList.add('active');
      var first = tabs[0].getAttribute('data-tab-target');
      var firstContent = section.querySelector('[data-tab-id="' + first + '"]');
      if (firstContent) firstContent.style.display = 'block';
    }
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var id = tab.getAttribute('data-tab-target');
        deactivate();
        tab.classList.add('active');
        var target = section.querySelector('[data-tab-id="' + id + '"]');
        if (target) target.style.display = 'block';
        var swiperEl = target.querySelector('.advanced-tabbed-section__swiper');
        if (swiperEl && swiperEl.swiper) swiperEl.swiper.update();
      });
    });
    section.querySelectorAll('.advanced-tabbed-section__swiper').forEach(function(swiperEl) {
      var d = parseInt(swiperEl.getAttribute('data-items-per-view')) || 3;
      var t = parseInt(swiperEl.getAttribute('data-items-per-view-tablet')) || 2;
      var m = parseInt(swiperEl.getAttribute('data-items-per-view-mobile')) || 1;
      new Swiper(swiperEl, {
        slidesPerView: d,
        spaceBetween: 24,
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true
        },
        breakpoints: {
          0: { slidesPerView: m },
          600: { slidesPerView: t },
          992: { slidesPerView: d }
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.advanced-tabbed-section').forEach(function(section) {
      initSection(section);
    });
  });
})();
(function() {
  function initSection(section) {
    var tabs = section.querySelectorAll('.advanced-tabbed-section__tab');
    var contents = section.querySelectorAll('.advanced-tabbed-section__content');
    function deactivate() {
      tabs.forEach(function(tab) { tab.classList.remove('active'); });
      contents.forEach(function(content) { content.style.display = 'none'; });
    }
    deactivate();
    if (tabs.length > 0) {
      tabs[0].classList.add('active');
      var first = tabs[0].getAttribute('data-tab-target');
      var firstContent = section.querySelector('[data-tab-id="' + first + '"]');
      if (firstContent) firstContent.style.display = 'block';
    }
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var id = tab.getAttribute('data-tab-target');
        deactivate();
        tab.classList.add('active');
        var target = section.querySelector('[data-tab-id="' + id + '"]');
        if (target) target.style.display = 'block';
        var swiperEl = target.querySelector('.advanced-tabbed-section__swiper');
        if (swiperEl && swiperEl.swiper) swiperEl.swiper.update();
      });
    });
    section.querySelectorAll('.advanced-tabbed-section__swiper').forEach(function(swiperEl) {
      var d = parseInt(swiperEl.getAttribute('data-items-per-view')) || 3;
      var t = parseInt(swiperEl.getAttribute('data-items-per-view-tablet')) || 2;
      var m = parseInt(swiperEl.getAttribute('data-items-per-view-mobile')) || 1;
      new Swiper(swiperEl, {
        slidesPerView: d,
        spaceBetween: 24,
        navigation: {
          nextEl: swiperEl.querySelector('.swiper-button-next'),
          prevEl: swiperEl.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: swiperEl.querySelector('.swiper-pagination'),
          clickable: true
        },
        breakpoints: {
          0: { slidesPerView: m },
          600: { slidesPerView: t },
          992: { slidesPerView: d }
        }
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.advanced-tabbed-section').forEach(function(section) {
      initSection(section);
    });
  });
})();
